import PropTypes from 'prop-types';
import React from 'react';
import { Box, Slide, Stack, Button, TextField, Typography } from '@mui/material';
import toast from 'react-hot-toast';
import _ from 'lodash';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import * as myLayananService from '../../../services/mylayanan';

RequestsVideotron.propTypes = {
  user: PropTypes.object.isRequired
};

export default function RequestsVideotron({ user }) {
  const navigate = useNavigate();
  const [nama, setNama] = React.useState('');

  const theme = useTheme();

  const createPermohonan = async () => {
    if (!user?.attributes?.id_instansi) return toast.error('ID Instansi tidak ditemukan');
    if (!user?.attributes?.id) return toast.error('ID User tidak ditemukan');
    if (!nama) return toast.error('Nama investasi tidak ditemukan');

    try {
      const body = {
        data: {
          type: 'videotron',
          id: '1',
          attributes: {
            id_kategori_layanan: 'videotron',
            id_instansi: user?.attributes?.id_instansi,
            requestor: user?.attributes?.id,
            status: 'draft',
            id_jenis_permohonan: 'videotron'
          },
          meta: {
            videotron: { name: nama }
          }
        }
      };

      const result = await myLayananService.addLayanan(body);

      if (result) {
        toast.success('Draft Permohonan berhasil dibuat');
        navigate(
          `/dashboard/services?page=1&size=${process.env.REACT_APP_PAGE_SIZE}&createdID=${result?.data?.id}&alert=1`,
          {
            replace: true
          }
        );
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <>
      <Slide direction="left" in="true" mountOnEnter unmountOnExit>
        <Box sx={{ flexDirection: 'column' }}>
          <Stack spacing={3} direction="column">
            <Box>
              <Stack direction="column" spacing={2}>
                <Box>
                  <Typography variant="body2">
                    Dinas Komunikasi dan Informatika DIY memberikan layanan fasilitasi publikasi
                    melalui Videotron bagi Intansi pemerintah baik daerah maupun pusat serta Lembaga
                    non-provit lainnya.
                  </Typography>
                </Box>

                <Stack direction="row">
                  <Box sx={{ flex: { xs: 12, sm: 6 } }}>
                    <TextField
                      value={nama}
                      onChange={(e) => setNama(e.target.value)}
                      fullWidth
                      label="Nama pemohon"
                    />
                  </Box>
                  <Box sx={{ flex: { xs: 0, sm: 6 } }} />
                </Stack>

                <Box>
                  <Button
                    disabled={!nama || nama.length < 3}
                    onClick={() => createPermohonan()}
                    variant="contained"
                  >
                    BUAT PERMOHONAN
                  </Button>
                </Box>
              </Stack>
            </Box>
          </Stack>
        </Box>
      </Slide>
    </>
  );
}
